<organization-select    #orgManager
                        autoSelectFirst = "true"
                        class           = "mr-3"
                        [enabled]       = "null"></organization-select>
                           
<organization-data-container [org] = "orgManager?.currentValue" 
                             (refresh) = "orgManager?.refreshData()"></organization-data-container> 